import { render } from "./CheckoutTable.vue?vue&type=template&id=62941070"
import script from "./CheckoutTable.vue?vue&type=script&lang=ts"
export * from "./CheckoutTable.vue?vue&type=script&lang=ts"
script.render = render

export default script